var __rspack_ns_object = JSON.parse('{"UU":"@ohif/extension-sycai","rE":"3.13.2"}')